<template>
  <div>
    <HausefulUsersListFilters />
    <HausefulUsersList />
    <HausefulUserCreateUpdate ref="createUpdate" />
    <HausefulUsersDeleteModal />
    <HausefulUsersSummary />
    <ModalCreateUserOnChecklist type="hausefulUser" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import HausefulUsersList from './hausefulUsers/components/HausefulUsersList'
import HausefulUsersSummary from './hausefulUsers/components/HausefulUsersSummary'
import HausefulUsersListFilters from './hausefulUsers/components/HausefulUsersListFilters'
import HausefulUserCreateUpdate from './hausefulUsers/components/HausefulUserCreateUpdate'
import HausefulUsersDeleteModal from './hausefulUsers/components/HausefulUsersDeleteModal'
import ModalCreateUserOnChecklist from '../components/host/modals/ModalCreateUserOnChecklist'

export default {
  name: 'HausefulUsers',

  components: {
    HausefulUsersList,
    HausefulUsersSummary,
    HausefulUsersListFilters,
    HausefulUserCreateUpdate,
    HausefulUsersDeleteModal,
    ModalCreateUserOnChecklist
  },

  methods: {
    ...mapActions(['handleOpenCreateUpdateHausefulUsersModal']),

    openCreateEdit() {
      this.$refs.createUpdate?.resetFields()
      this.handleOpenCreateUpdateHausefulUsersModal()
    },
  }
}
</script>
